import React, { Component } from "react";
import { observer } from "mobx-react";
import PropTypes from "prop-types";
import { Card, Icon, Label, List } from "semantic-ui-react";
import { withTranslation } from "react-i18next";
import OtherProduct from "~/models/OtherProduct";
import CommonHelper from "~/utils/CommonHelper";
import UiMeet3dPackageInfos from "~/constants/UiMeet3d/UiMeet3dPackageInfos";
import "../styles/OtherProductCard.less";

@observer
class OtherProductCard extends Component {
  render() {
    const { otherProduct, addSubscriptionItemCallback, selectedOtherProductIds, t, quantity } = this.props;

    const uiMeet3dPackageInfo = UiMeet3dPackageInfos[otherProduct.otherProductId];

    return (
      <Card
        color={uiMeet3dPackageInfo.color}
        link={!selectedOtherProductIds.includes(otherProduct.otherProductId)}
        onClick={
          !selectedOtherProductIds.includes(otherProduct.otherProductId)
            ? () => addSubscriptionItemCallback(otherProduct.otherProductId)
            : null
        }
      >
        <Card.Content className="center aligned">
          <Card.Header>{t(uiMeet3dPackageInfo.shortNameTranslationKey)}</Card.Header>
        </Card.Content>
        <Card.Content className="center aligned">
          <p>
            <strong>
              <span
                className="ui large text"
                style={{ color: uiMeet3dPackageInfo.colorCode ?? uiMeet3dPackageInfo.color }}
              >
                {CommonHelper.currencyFormat(parseFloat(otherProduct.price))}
              </span>
            </strong>
          </p>
        </Card.Content>
        <Card.Content>
          <Card.Description>
            <List>
              <List.Item>
                <Icon name="check" size="large" color="green" />
                <List.Content>
                  <List.Header>
                    {uiMeet3dPackageInfo.activeTours < 1000000 ? (
                      <span
                        style={{ display: "table-cell" }}
                        dangerouslySetInnerHTML={{
                          __html: t("billingCentral:uiMeet3dPackageActiveToursPerMonth", {
                            count: uiMeet3dPackageInfo.activeTours,
                            color: uiMeet3dPackageInfo.colorCode ?? uiMeet3dPackageInfo.color,
                          }),
                        }}
                      />
                    ) : (
                      <span
                        style={{ display: "table-cell" }}
                        dangerouslySetInnerHTML={{
                          __html: t("billingCentral:uiMeet3dPackageUnlimitedActiveTours", {
                            color: uiMeet3dPackageInfo.colorCode ?? uiMeet3dPackageInfo.color,
                          }),
                        }}
                      />
                    )}
                  </List.Header>
                </List.Content>
              </List.Item>
              <List.Item>
                <Icon name="check" size="large" color="green" />
                <List.Content>
                  <List.Header>
                    {uiMeet3dPackageInfo.minutes < 1000000 ? (
                      <span
                        style={{ display: "table-cell" }}
                        dangerouslySetInnerHTML={{
                          __html: t("billingCentral:uiMeet3dPackageMinutesPerMonth", {
                            minutes: uiMeet3dPackageInfo.minutes,
                            color: uiMeet3dPackageInfo.colorCode ?? uiMeet3dPackageInfo.color,
                          }),
                        }}
                      />
                    ) : (
                      <span
                        style={{ display: "table-cell" }}
                        dangerouslySetInnerHTML={{
                          __html: t("billingCentral:uiMeet3dPackageUnlimitedMinutes", {
                            color: uiMeet3dPackageInfo.colorCode ?? uiMeet3dPackageInfo.color,
                          }),
                        }}
                      />
                    )}
                  </List.Header>
                </List.Content>
              </List.Item>
              <List.Item>
                <Icon name="check" size="large" color="green" />
                <List.Content>
                  <List.Header>
                    {uiMeet3dPackageInfo.notifications < 1000000 ? (
                      <span
                        style={{ display: "table-cell" }}
                        dangerouslySetInnerHTML={{
                          __html: t("billingCentral:uiMeet3dPackageNotificationsPerMonth", {
                            notifications: uiMeet3dPackageInfo.notifications,
                            color: uiMeet3dPackageInfo.colorCode ?? uiMeet3dPackageInfo.color,
                          }),
                        }}
                      />
                    ) : (
                      <span
                        style={{ display: "table-cell" }}
                        dangerouslySetInnerHTML={{
                          __html: t("billingCentral:uiMeet3dPackageUnlimitedNotifications", {
                            color: uiMeet3dPackageInfo.colorCode ?? uiMeet3dPackageInfo.color,
                          }),
                        }}
                      />
                    )}
                  </List.Header>
                </List.Content>
              </List.Item>
              <List.Item>
                <Icon name="check" size="large" color="green" />
                <List.Content>
                  <List.Header>
                    {uiMeet3dPackageInfo.leads < 1000000 ? (
                      <span
                        style={{ display: "table-cell" }}
                        dangerouslySetInnerHTML={{
                          __html: t("billingCentral:uiMeet3dPackageLeadsPerMonth", {
                            leads: uiMeet3dPackageInfo.leads,
                            color: uiMeet3dPackageInfo.colorCode ?? uiMeet3dPackageInfo.color,
                          }),
                        }}
                      />
                    ) : (
                      <span
                        style={{ display: "table-cell" }}
                        dangerouslySetInnerHTML={{
                          __html: t("billingCentral:uiMeet3dPackageUnlimitedLeads", {
                            color: uiMeet3dPackageInfo.colorCode ?? uiMeet3dPackageInfo.color,
                          }),
                        }}
                      />
                    )}
                  </List.Header>
                </List.Content>
              </List.Item>
            </List>
          </Card.Description>
          {selectedOtherProductIds.includes(otherProduct.otherProductId) && (
            <Label attached="bottom right">{quantity ? `x${quantity}` : t("billingCentral:inUse")}</Label>
          )}
        </Card.Content>
      </Card>
    );
  }
}

OtherProductCard.propTypes = {
  t: PropTypes.func.isRequired,
  otherProduct: PropTypes.instanceOf(OtherProduct),
  addSubscriptionItemCallback: PropTypes.func,
  selectedOtherProductIds: PropTypes.array.isRequired,
  quantity: PropTypes.number,
};

OtherProductCard.defaultProps = {
  quantity: null,
};

export default withTranslation()(OtherProductCard);
